import React from 'react';
import { Link } from 'react-router-dom';
import './Zoom.css';

const ZoomExplanation = () => {
  return (
    <div className="zoom-explanation-container">
      <div className="zoom-explanation-content">
        <h1>Your Webinar Confirmation</h1>
        
        <div className="confirmation-card">
          <div className="confirmation-icon">
            <svg viewBox="0 0 24 24" width="64" height="64">
              <circle cx="12" cy="12" r="11" fill="#4CAF50" />
              <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" fill="white" />
            </svg>
          </div>
          
          <h2>You're all set!</h2>
          <p className="explanation-text">
            Thank you for scheduling your webinar with B&B Global Solutions. Your webinar will be held on the date you selected in Calendly.
          </p>
          
          <div className="info-box">
            <h3>Important Information</h3>
            <ul>
              <li>You will receive a reminder email before the webinar with all details</li>
              <li>The webinar will be hosted on Zoom</li>
              <li>When it's time for your webinar, simply visit: <span className="highlight">bbglobalsolutions.org/zoom</span></li>
              <li>Alternative link: <span className="highlight">miguelangelbeas.com/zoom</span></li>
              <li>Have your questions ready - we'll have time for Q&A</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ZoomExplanation; 